module.exports = [{
      plugin: require('/builds/maximenavet/astraliker/node_modules/gatsby-plugin-offline/gatsby-browser'),
      options: {"plugins":[]},
    },{
      plugin: require('/builds/maximenavet/astraliker/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
